import React from 'react';
import { translate } from '@utils/i18n';
import { IndexNamespace } from '@features/ActivityFeed/constants';
import defaultDetailStrategy from './defaultDetailStrategy';
const PROPOSAL_REQUEST_KEY = 'proposal_request';
export default function proposalRequestDetailStrategy() {
    const fallback = defaultDetailStrategy();
    return {
        appliesTo: (key) => key === PROPOSAL_REQUEST_KEY,
        render: (key, newValue, oldValue, versionEvent) => {
            if (oldValue === true && newValue === false) {
                return React.createElement("span", { key: key }, translate('converted_from_proposal_request', { namespace: IndexNamespace }));
            }
            return fallback.render(key, newValue, oldValue, versionEvent);
        }
    };
}
